module.exports = __webpack_public_path__ + "dfe5d2e2b1575f2e8534237ced2c0dcc.svg";